export default __webpack_public_path__ + "static/process-between-designers-etc-0754a4398bdfe163f455e749a5ca17a4.png";